export var NotificationState;
(function (NotificationState) {
    NotificationState["INFO"] = "info";
    NotificationState["ERROR"] = "error";
    NotificationState["SUCCESS"] = "success";
})(NotificationState || (NotificationState = {}));
//# sourceMappingURL=MsNotification.js.map